import { render, staticRenderFns } from "./addServiceDetail.vue?vue&type=template&id=c972684e&scoped=true"
import script from "./addServiceDetail.vue?vue&type=script&lang=js"
export * from "./addServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./addServiceDetail.vue?vue&type=style&index=0&id=c972684e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c972684e",
  null
  
)

export default component.exports